import { render } from "./SofticiBadge.vue?vue&type=template&id=896a0114&scoped=true"
import script from "./SofticiBadge.vue?vue&type=script&lang=js"
export * from "./SofticiBadge.vue?vue&type=script&lang=js"

import "./SofticiBadge.vue?vue&type=style&index=0&id=896a0114&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\tomda\\PhpstormProjects\\cerstve-urtzeno-hana-a.s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-896a0114"]])

export default __exports__